export const ItemWeightUnits = [
  'lb',
  'oz',
  'fl',
  'gm',
  'kg',
  'ct',
  'gal',
  'pint',
  'each',
  'NA',
];

export const RunReceiptPrefixURL = 'https://users-order-images.gobuncha.com';
export const upcImagePrefixURL = 'https://upcimages.gobuncha.com';
export const awsRegion = 'us-east-1';

export const groupConversationFilter = {
  custom: {
    status: ['==', 'open'],
    name: ['==', 'operation_support_chat_group'],
  },
};

export const permissionRequiredStatuses = [
  'denied',
  'not-determined',
  'restricted',
  'never_ask_again',
];

export const COMMON_ERROR_MESSAGE =
  'We apologize, but we’re experiencing technical difficulties fetching the data at the moment. Please connect with customer support.';

export const NON_SERVER_COMMON_ERROR_MESSAGE =
  'We apologize for the inconvenience. Please retry later or contact customer support if the issue persists.';

export const GENERIC_ERROR_CLASS = 'GenericError';
export const printerLocalName = 'buncha';
export const AccuracyPercentageCheckValue = 80;

export const QUERY_TIMEOUT_MS = 20000;
export const MUTATION_TIMEOUT_MS = 40000;

export const REQUEST_TIMEOUT = 'Request timed out';
export const ONE_DAY_TIMEOUT_MS = 86400000;
